import { render, staticRenderFns } from "./examination-drawer.vue?vue&type=template&id=42031a39&"
import script from "./examination-drawer.vue?vue&type=script&lang=js&"
export * from "./examination-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports